// extracted by mini-css-extract-plugin
module.exports = {"secondaryControlContainer":"SecondaryControls_secondaryControlContainer__3oSF2","controlButton":"SecondaryControls_controlButton__3AFIV"};